import React from 'react';
import { ImageIcon } from 'lucide-react';
type ClipboardSheetProps = {
  image: string;
  label: string;
  tilt: number;
};

/** A printed page clipped to a coach's clipboard, slightly tilted. */
export function ClipboardSheet({
  image,
  label,
  tilt
}: ClipboardSheetProps) {
  return <div className="relative rounded-[14px] bg-clay-deep px-3 pb-3 pt-7 shadow-[0_28px_50px_-14px_rgba(0,0,0,0.65),0_6px_14px_rgba(0,0,0,0.25)]" style={{
    transform: `rotate(${tilt}deg)`
  }} data-id="element-56" data-mp="39c88v6f0nzic">
      {/* metal clip */}
      <div className="absolute left-1/2 top-[-10px] h-8 w-28 -translate-x-1/2 rounded-md bg-[#CDD2D9] shadow-[inset_0_-3px_0_rgba(0,0,0,0.2),0_3px_6px_rgba(0,0,0,0.35)]" data-id="element-57" data-mp="3j0q6jes01qhr">
        <div className="mx-auto mt-2 h-2 w-14 rounded-full bg-[#9AA1AB]" data-id="element-58" data-mp="3s2ppwdqhl6nv" />
      </div>

      {image ? <img src={image} alt={label} className="block h-[352px] w-auto rounded-[2px] bg-white" data-id="element-59" data-mp="22n0041deqq4y" /> : <div className="flex h-[352px] w-[198px] flex-col items-center justify-center gap-2 rounded-[2px] border-2 border-dashed border-ink-muted bg-white px-4 text-center" data-id="element-60" data-mp="1xq9kff5ilwk2">
          <ImageIcon className="h-6 w-6 text-ink-muted" aria-hidden="true" data-id="element-61" data-mp="1sxr88zw3jnh8" />
          <span className="text-[11px] font-semibold text-ink-soft" data-id="element-62" data-mp="1wxromq2ra8qx">
            {label}
          </span>
        </div>}
    </div>;
}